import StatusIcon from "@/assets/icons/web_Icons/status-up.svg";
import DocumentIcon from "@/assets/icons/web_Icons/document-text.svg";
import CameraIcon from "@/assets/icons/web_Icons/camera_(2).svg";
import ChartIcon from "@/assets/icons/web_Icons/favorite-chart.svg";
import DriverIcon from "@/assets/icons/web_Icons/driver-refresh.svg";
import OptionsImg from "@/assets/icons/web_Icons/more.svg";
import { useNavigate } from "react-router-dom";

const UpcomingEvents = () => {
  const navigate = useNavigate();
  const events = [
    {
      icon: StatusIcon,
      title: "Onboard Presidential Elect...",
      time: "Next 2 Hours",
      bgColor: "bg-[#F00000]",
    },
    {
      icon: DocumentIcon,
      title: "Follow-up with Jimi on the...",
      time: "Next 2 Hours",
      bgColor: "bg-[#F1AC29]",
    },
    {
      icon: CameraIcon,
      title: "Visit the Lekki tollgate for...",
      time: "Next 2 Hours",
      bgColor: "bg-[#0F75BC]",
    },
    {
      icon: ChartIcon,
      title: "Assign new tasks to the e...",
      time: "Next 2 Hours",
      bgColor: "bg-[#18965A]",
    },
    {
      icon: DriverIcon,
      title: "Create a Manifesto for the...",
      time: "Next 2 Hours",
      bgColor: "bg-[#9747FF]",
    },
  ];

  return (
    <div className="w-full mb-5">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-xl font-bold">Upcoming Events</h2>
        <button className="text-sm font-medium text-primary"  onClick={() => navigate("/dashboard/events")}>View all</button>
      </div>
      <div className="space-y-1 w-full">
        {events.map((event, index) => (
          <div
            key={index}
            className="flex items-center justify-between p-3 bg-[var(--header-bg)] rounded-lg w-full">
            <div
              className={`w-10 h-10 flex items-center justify-center rounded-lg ${event.bgColor}`}>
              <img src={event.icon} alt="" />
            </div>
            <div className="flex-1 ml-4">
              <h3 className="text-sm font-medium text-black truncate">
                {event.title}
              </h3>
              <p className="text-xs dark-mode-text">{event.time}</p>
            </div>
            <img src={OptionsImg} className="w-4" alt="" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default UpcomingEvents;
